// components/MemberLogin.js
import React, { useState } from 'react';
import axios from 'axios';
import './Login.css';

const API_URL = process.env.REACT_APP_API_URL;

const MemberLogin = ({ onLogin }) => {
  const [memberNumber, setMemberNumber] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleLogin = async (e) => {
    e.preventDefault(); // Prevent page reload
    if (!memberNumber || !password) {
      setError('Please enter member number and password');
      return;
    }
    setLoading(true);
    try {
      const response = await axios.post(`${API_URL}/login/member`, {
        memberNumber,
        password,
      });
      onLogin(response.data, 'member');
    } catch (err) {
      setError(err.response?.data?.message || 'Login failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-page">
      <div className="login-container">
        <div className="login-card">
          <h2>Member Login</h2>

          <form onSubmit={handleLogin} className="login-form">
            <div className="form-group">
              <label htmlFor="memberNumber">Member Number</label>
              <input
                type="text"
                id="memberNumber"
                value={memberNumber}
                onChange={(e) => setMemberNumber(e.target.value)}
                placeholder="Enter your mobile number"
              />
            </div>

            <div className="form-group">
              <label htmlFor="password">Password</label>
              <input
                type="password"
                id="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="Enter password"
              />
            </div>

            {error && <div className="error-message">{error}</div>}

            <button type="submit" className="login-button" disabled={loading}>
              {loading ? 'Logging in...' : 'Login'}
            </button>
          </form>
        </div>
      </div>

      {/* Footer at bottom of page */}
      <footer className="page-footer">
        <a href="/terms" target="_blank" rel="noopener noreferrer">Terms & Conditions</a> |{' '}
        <a href="/privacy" target="_blank" rel="noopener noreferrer">Privacy Policy</a> |{' '}
        <a href="/refund" target="_blank" rel="noopener noreferrer">Refund Policy</a> |{' '}
        <a href="/contact" target="_blank" rel="noopener noreferrer">Contact Us</a>
      </footer>
    </div>
  );
};

export default MemberLogin;
